import type { StateCreator } from 'zustand'
import type { Gift, GiftInPackage, GiftType } from '../../types/lives/messages'

interface State {
  giftsTypes: GiftType[]
  giftsInPackageTypes: null | GiftInPackage[]
  selectedType: GiftType
  giftSelected: Gift | null
  quantity: number
  usersToGift: Set<number>
  isSelectedAll: boolean
  isModalOpenWhileSendingGift: boolean | null
  isSendQuick: boolean
}

export type LiveGiftSlice = State

export const liveGiftStore: StateCreator<
  LiveGiftSlice,
  [],
  [],
  LiveGiftSlice
> = () => ({
  giftsTypes: [],
  giftsInPackageTypes: null,
  selectedType: {} as GiftType,
  giftSelected: {} as Gift,
  quantity: 0,
  usersToGift: new Set(),
  isSelectedAll: false,
  isSendQuick: false,
  isModalOpenWhileSendingGift: null,
})
